const initialState = (window.initialStoreState && window.initialStoreState.page) || {}

export default function reducer(state=initialState, action={}) {
  switch (action.type) {
    case 'FETCH_PAGE_PENDING': {
      return {}
    }
    case 'FETCH_PAGE_FULFILLED': {
      return { data: action.payload }
    }
    case 'FETCH_PAGE_REJECTED': {
      var error = action.payload
      return { 
        error: {
          'status': error.status, 
          'statusText': error.statusText, 
          'response': error.response 
        }
      }
    }
    default: {
      return state
    }
  }
}

